export const LIST_OF_RIGHTS_GROUPS = ["smc", "see", "spr", "sbs", "tts", "qas", "ses", "cls", "res", "auth", "marks", "transcription", "server", "lang"];

export const USER = {
	RIGHTS_LIST: "GET:/auth/rights", // должен быть доступен всегда по access-токену
	ACCESS: "POST:/auth/access", // доступен без токенов
	REFRESH: "GET:/auth/refresh", // доступен по refresh-токену
	PASSWORD: "POST:/auth/user/password",
	DATASET: "POST:/auth/user/dataset",
	CURRENT_USER_INFO: "GET:/auth/user/info", // должен быть доступен всегда по access-токену
	LIST: "GET:/auth/user/list",
	USER_INFO: "GET:/auth/user/get",
	ADD: "POST:/auth/user/add",
	MODIFY: "POST:/auth/user/modify",
	DELETE: "DELETE:/auth/user/delete",
	VERSION: "GET:/auth/version",
	LOGS: "POST:/auth/userlog",
};

export const ROLE = {
	LIST: "GET:/auth/roles", // должен быть доступен всегда по access-токену
	ADD: "POST:/auth/role/add",
	EDIT: "POST:/auth/role/modify",
	DELETE: "DELETE:/auth/role/delete",
};

export const DATASET = {
	LIST: "GET:/auth/datasets",
	ADD: "POST:/auth/dataset/add",
	EDIT: "POST:/auth/dataset/modify",
	DELETE: "DELETE:/auth/dataset/delete",
};

export const MARKS = {
	LIST: "GET:/marks/list",
	GET: "GET:/marks/get",
	ADD: "POST:/marks/add",
	RENAME: "POST:/marks/rename",
	MODIFY: "POST:/marks/modify",
	COPY: "POST:/marks/copy",
	DELETE: "DELETE:/marks/delete",
	IMPORT: "POST:/marks/import",
	EXPORT: "GET:/marks/export",
};

export const SERVER = {
	ADDRESSES: "GET:/server/get/addresses",
};

export const SMC = {
	LIST: "GET:/smc/models",
	INFO: "GET:/smc/info",

	IMPORT: "POST:/smc/import",
	EXPORT: "GET:/smc/export",
	DELETE: "DELETE:/smc/delete",
	COPY: "POST:/smc/copy",

	TRAIN: "POST:/smc/train",
	STOP_TRAIN: "POST:/smc/stop",
	UPDATE_GROUPS: "POST:/smc/groups",
	TEST: "POST:/smc/test",
	CLASSIFY: "GET:/smc/classify",
	EMOTION: "GET:/smc/emotion",
	PUNCTUATE: "GET:/smc/punctuate",
	CORRECT: "GET:/smc/correct",
	NORMALIZE: "GET:/smc/normalize",
	TOXICITY: "GET:/smc/toxicity",

	LOG: "GET:/smc/log",
	ERRORS: "GET:/smc/errors",

	GET_HANDLER: "GET:/smc/handler",
	SAVE_HANDLER: "POST:/smc/handler",
	DELETE_HANDLER: "DELETE:/smc/handler",

	AUTOMARK_START: "POST:/smc/automark/start",
	AUTOMARK_STOP: "GET:/smc/automark/stop",
	AUTOMARK_STATUS: "GET:/smc/automark/status",
	AUTOMARK_LIST: "GET:/smc/automark/list",
	AUTOMARK_RESULT: "GET:/smc/automark/result",
};

export const SEE = {
	LIST: "GET:/see/models",
	INFO: "GET:/see/info",

	IMPORT: "POST:/see/import",
	EXPORT: "GET:/see/export",
	DELETE: "DELETE:/see/delete",
	COPY: "POST:/see/copy",

	TRAIN: "POST:/see/train",
	STOP_TRAIN: "POST:/see/stop",
	SEARCH_ENTITIES: "GET:/see/entities",

	LOG: "GET:/see/log",
	ERRORS: "GET:/see/errors",

	GET_HANDLER: "GET:/see/handler",
	SAVE_HANDLER: "POST:/see/handler",
	DELETE_HANDLER: "DELETE:/see/handler",
};

export const SPR = {
	LIST: "GET:/spr/models",
	IMPORT: "POST:/spr/import",
	EXPORT: "GET:/spr/export",
	DELETE: "DELETE:/spr/delete",

	RECOGNITION: "POST:/spr/stt",
	ASYNC_RESULT: "GET:/spr/result",
	DELETE_TASK: "DELETE:/spr/queue",
	QUEUE: "GET:/spr/queue",
	AUDIO: "GET:/spr/audio",
	WAVEFORM: "GET:/spr/waveform",
};

export const TRANSCRIPTION = {
	LIST: "GET:/transcription/list",
	GET_DATA: "GET:/transcription/get",
	GET_AUDIO: "GET:/transcription/audio",
	WAVEFORM: "GET:/transcription/waveform",
	CREATE: "POST:/transcription/create",
	MODIFY: "POST:/transcription/modify",
	SAVE: "POST:/transcription/save",
	DELETE: "DELETE:/transcription/delete",
	METRICS: "GET:/transcription/errors",
};

export const SBS = {
	SPEAKERS: "GET:/sbs/speakers/list",
	SPEAKER_ADD: "POST:/sbs/speakers/add",
	SPEAKER_EDIT: "POST:/sbs/speakers/modify",
	SPEAKER_DELETE: "DELETE:/sbs/speakers/delete",
	ANALYZE: "POST:/sbs/analyze",
	NOISE_LEVEL: "POST:/sbs/noiselevel",
	SEARCH: "POST:/sbs/search",
	VERIFY: "POST:/sbs/verify",
};

export const TTS = {
	LIST: "GET:/tts/models",

	SYNTHESIS: "POST:/tts/synthesize",
	NORMALIZE: "POST:/tts/normalize",
	PHONEMES: "POST:/tts/phonemes",
	REVOICERS_LIST: "GET:/tts/revoicers",
	REVOICE: "POST:/tts/revoice",

	DICTIONARY_GET: "GET:/tts/dictionary/get",
	DICTIONARY_IMPORT: "POST:/tts/dictionary/import",
	DICTIONARY_EXPORT: "GET:/tts/dictionary/export",
	DICTIONARY_SAVE: "POST:/tts/dictionary/put",
};

export const QAS = {
	SEARCH: "GET:/qas/search",
	ASK: "GET:/qas/ask",
	GPT_LIST: "GET:/qas/gpt/list",
	CHAT: "POST:/qas/chat",
	PARAPHRASE: "POST:/qas/paraphrase",
	REPLACEMENT_LIST: "GET:/qas/replacementlist",
	REPLACE: "POST:/qas/replace",
	COMPARE: "POST:/qas/compare",

	DOC_LIST: "GET:/qas/doc/list",
	DOC_GET: "GET:/qas/doc/get",
	DOC_ADD: "POST:/qas/doc/add",
	DOC_EDIT: "POST:/qas/doc/modify",
	DOC_DELETE: "DELETE:/qas/doc/delete",
	DOC_GENERATE_ANNOTATION: "POST:/qas/doc/generate_annotation",
	DOC_REPLACE: "POST:/qas/doc/replace",
	DOC_PHRASES_EDIT: "POST:/qas/doc/modifyphrases",

	QUESTION_LIST: "GET:/qas/question/list",
	QUESTION_GET: "GET:/qas/question/get",
	QUESTION_ADD: "POST:/qas/question/add",
	QUESTION_EDIT: "POST:/qas/question/modify",
	QUESTION_DELETE: "DELETE:/qas/question/delete",
	QUESTION_LIST_DELETE: "POST:/qas/question/delete/list",
	QUESTION_APPEND: "POST:/qas/question/append",
	QUESTION_APPROVE: "POST:/qas/question/approve",
	QUESTION_REPLACE: "POST:/qas/question/replace",
	QUESTION_ANSWERS_EDIT: "POST:/qas/question/modifyanswers",

	CATEGORY_LIST: "GET:/qas/category/list",
	CATEGORY_ADD: "POST:/qas/category/add",
	CATEGORY_EDIT: "POST:/qas/category/modify",
	CATEGORY_DELETE: "DELETE:/qas/category/delete",
	CATEGORY_IMPORT: "POST:/qas/category/import",
	CATEGORY_EXPORT: "GET:/qas/category/export",

	ANSWER_MAKER_START: "GET:/qas/cachemaker/start",
	ANSWER_MAKER_STOP: "GET:/qas/cachemaker/stop",
	ANSWER_MAKER_STATUS: "GET:/qas/cachemaker/status",

	QUESTION_MAKER_START: "GET:/qas/questionmaker/start",
	QUESTION_MAKER_STOP: "GET:/qas/questionmaker/stop",
	QUESTION_MAKER_STATUS: "GET:/qas/questionmaker/status",

	PROCESSING_QUESTIONS_START: "POST:/qas/questionlist/start",
	PROCESSING_QUESTIONS_STOP: "GET:/qas/questionlist/stop",
	PROCESSING_QUESTIONS_STATUS: "GET:/qas/questionlist/status",
	PROCESSING_QUESTIONS_LOG: "GET:/qas/questionlist/answers",

	COPY_ANSWERS_WITH_CLEANING_START: "POST:/qas/answerslist/start",
	COPY_ANSWERS_WITH_CLEANING_STOP: "GET:/qas/answerslist/stop",
	COPY_ANSWERS_WITH_CLEANING_STATUS: "GET:/qas/answerslist/status",
	COPY_ANSWERS_WITH_CLEANING_LOG: "GET:/qas/answerslist/answers",

	SUMMARIZE: "POST:/qas/summarize",
	TEMPLATE_LIST: "GET:/qas/summarization_template/list",
	TEMPLATE_GET: "GET:/qas/summarization_template/get",
	TEMPLATE_ADD: "POST:/qas/summarization_template/add",
	TEMPLATE_EDIT: "POST:/qas/summarization_template/modify",
	TEMPLATE_DELETE: "DELETE:/qas/summarization_template/delete",

	PROMPT_LIST: "GET:/qas/prompt/list",
	PROMPT_GET: "GET:/qas/prompt/get",
	PROMPT_ADD: "POST:/qas/prompt/add",
	PROMPT_EDIT: "POST:/qas/prompt/modify",
	PROMPT_DELETE: "DELETE:/qas/prompt/delete",

	MISMATCH_SEARCHER_START: "POST:/qas/mismatchsearcher/start",
	MISMATCH_SEARCHER_STOP: "GET:/qas/mismatchsearcher/stop",
	MISMATCH_SEARCHER_STATUS: "GET:/qas/mismatchsearcher/status",
	MISMATCH_SEARCHER_LOG: "GET:/qas/mismatchsearcher/mismatches",

	CLEAN_DOC_START: "POST:/qas/cleandoc/start",
	CLEAN_DOC_STOP: "GET:/qas/cleandoc/stop",
	CLEAN_DOC_STATUS: "GET:/qas/cleandoc/status",
	CLEAN_DOC_RESULT: "GET:/qas/cleandoc/result",
};

export const SES = {
	ROBOT_LIST: "GET:/ses/robot/list",
	ROBOT_GET: "GET:/ses/robot/get",
	ROBOT_ADD: "POST:/ses/robot/add",
	ROBOT_EDIT: "POST:/ses/robot/modify",
	ROBOT_DELETE: "DELETE:/ses/robot/delete",
	ROBOT_COMMIT_CONFIG: "POST:/ses/robot/commit",
	ROBOT_APPLY: "POST:/ses/robot/apply",
	ROBOT_RESTORE: "POST:/ses/robot/restore",
	ROBOT_CLEAR_DRAFT: "POST:/ses/robot/cleardraft",
	ROBOT_IMPORT: "POST:/ses/robot/import",
	ROBOT_EXPORT: "GET:/ses/robot/export",
	ROBOT_SEARCH: "POST:/ses/robot/search",

	DATA_LIST: "GET:/ses/robot/data/list",
	DATA_GET: "GET:/ses/robot/data/get",
	DATA_ADD: "POST:/ses/robot/data/add",
	DATA_EDIT: "POST:/ses/robot/data/modify",
	DATA_DELETE: "DELETE:/ses/robot/data/delete",

	ENDPOINT_LIST: "GET:/ses/robot/endpoint/list",
	ENDPOINT_GET: "GET:/ses/robot/endpoint/get",
	ENDPOINT_ADD: "POST:/ses/robot/endpoint/add",
	ENDPOINT_EDIT: "POST:/ses/robot/endpoint/modify",
	ENDPOINT_DELETE: "DELETE:/ses/robot/endpoint/delete",

	SCRIPT_LIST: "GET:/ses/robot/script/list",
	SCRIPT_GET: "GET:/ses/robot/script/get",
	SCRIPT_ADD: "POST:/ses/robot/script/add",
	SCRIPT_EDIT: "POST:/ses/robot/script/modify",
	SCRIPT_DELETE: "DELETE:/ses/robot/script/delete",
	SCRIPT_TEST: "POST:/ses/robot/script/test",

	ASK: "POST:/ses/ask",
	SESSION: "GET:/ses/session",

	UPLOAD_FILE: "POST:/ses/robot/files/upload",
	DOWNLOAD_FILE: "GET:/ses/robot/files/download",

	WIDGET: "GET:/ses/widget/js",
	WIDGET_CONFIG: "GET:/ses/widget/config",

	ARCHIVE_LIST: "GET:/ses/archive/list",
	ARCHIVE_DIALOG: "GET:/ses/archive/dialog",
	ARCHIVE_AUDIO: "GET:/ses/archive/audio",
	ARCHIVE_WAVEFORM: "GET:/ses/archive/waveform",

	USERDATA_STRUCTURE_LIST: "GET:/ses/robot/userdata/structure/list",
	USERDATA_STRUCTURE_ADD: "POST:/ses/robot/userdata/structure/add",
	USERDATA_STRUCTURE_MODIFY: "POST:/ses/robot/userdata/structure/modify",
	USERDATA_STRUCTURE_DELETE: "DELETE:/ses/robot/userdata/structure/delete",

	USERDATA_DATA_LIST: "GET:/ses/robot/userdata/data/list",
	USERDATA_DATA_ADD: "POST:/ses/robot/userdata/data/add",
	USERDATA_DATA_MODIFY: "POST:/ses/robot/userdata/data/modify",
	USERDATA_DATA_PUT: "POST:/ses/robot/userdata/data/put",
	USERDATA_DATA_DELETE: "DELETE:/ses/robot/userdata/data/delete",

	CONNECTOR_LIST: "GET:/ses/robot/connector/list",
	CONNECTOR_ADD: "POST:/ses/robot/connector/add",
	CONNECTOR_MODIFY: "POST:/ses/robot/connector/modify",
	CONNECTOR_DELETE: "DELETE:/ses/robot/connector/delete",

	HANDLER_LIST: "GET:/ses/handler/list",
};

export const CLS = {
	// Конфигурации
	CONFIGS_GET: "GET:/cls/configs/get/",
	CONFIGS_LIST: "GET:/cls/configs/list",
	CONFIGS_MODIFY: "PUT:/cls/configs/modify/",

	// Инстансы
	INSTANCES_GET: "GET:/cls/instances/get/",
	INSTANCES_LIST: "GET:/cls/instances/list",
	INSTANCES_ADD: "POST:/cls/instances/add/",
	INSTANCES_REMOVE: "DELETE:/cls/instances/remove/",

	// Списки
	LISTS_LIST: "GET:/cls/lists/list",
	LISTS_LIST_ALT: "GET:/cls/lists/list/",
	LISTS_EXPORT: "GET:/cls/lists/export/",
	LISTS_STATUS: "GET:/cls/lists/status/",
	LISTS_ADD: "POST:/cls/lists/add",
	LISTS_IMPORT: "POST:/cls/lists/import/",
	LISTS_LOAD: "POST:/cls/lists/load/",
	LISTS_MODIFY: "PUT:/cls/lists/modify/",
	LISTS_DELETE: "DELETE:/cls/lists/delete/",

	// Временные интервалы
	TIMEINTERVALS_GET: "GET:/cls/timeintervals/get/",
	TIMEINTERVALS_LIST: "GET:/cls/timeintervals/list",
	TIMEINTERVALS_ADD: "POST:/cls/timeintervals/add",
	TIMEINTERVALS_MODIFY: "PUT:/cls/timeintervals/modify/",
	TIMEINTERVALS_DELETE: "DELETE:/cls/timeintervals/delete/",

	// Планировщик
	SCHEDULER_GET: "GET:/cls/scheduler/jobs/",
	SCHEDULER_PAUSE: "POST:/cls/scheduler/pause/",
	SCHEDULER_RESUME: "POST:/cls/scheduler/resume/",

	// Логи
	LOGS: "GET:/cls/logs/logs",

	// Управление вызовами
	CALL: "POST:/cls/calls/call",
	START: "POST:/cls/calls/start",
	STOP: "POST:/cls/calls/stop",
};

export const RES = {
	DASHBOARDS: "GET:/res/dashboards",
	CUSTOM_FIELDS: "GET:/res/customfields",
};

export const LANG = {
	LIST: "GET:/lang/list", // доступен без токенов
	LANG: "GET:/lang/", // доступен без токенов
	WALLPAPER: "GET:/lang/wallpaper", // доступен без токенов
	CHANNELS: "GET:/lang/channels",
};

export const SERVICE = {
	SMC: "SERVICE:smc",
	SEE: "SERVICE:see",
	SPR: "SERVICE:spr",
	SBS: "SERVICE:sbs",
	TTS: "SERVICE:tts",
	QAS: "SERVICE:qas",
	SES: "SERVICE:ses",
	CLS: "SERVICE:cls",
	RES: "SERVICE:res",
	AUTH: "SERVICE:auth",
};

export const ACCESS_RIGHTS_TO_PAGES = {
	SMC_MODELS: [SERVICE.SMC, SMC.LIST],
	SMC_CORPUS: [SERVICE.SMC, MARKS.LIST],
	SMC_MARKS: [SERVICE.SMC, MARKS.LIST],
	SEE_MODELS: [SERVICE.SEE, SEE.LIST],
	SEE_CORPUS: [SERVICE.SEE, MARKS.LIST],
	SPR_QUEUE: SERVICE.SPR,
	SPR_TRANSCRIPT: [SERVICE.SPR, TRANSCRIPTION.LIST],
	SBS: [SERVICE.SBS, SBS.SPEAKERS],
	TTS: [SERVICE.TTS, TTS.LIST],
	QAS_DOC: [SERVICE.QAS, QAS.DOC_LIST],
	QAS_QUESTION: [SERVICE.QAS, QAS.QUESTION_LIST],
	QAS_INTERACTIVE: [SERVICE.QAS, QAS.SUMMARIZE],
	SES: [SERVICE.SES, SES.ROBOT_LIST],
	CLS: SERVICE.CLS,
	RES: [SERVICE.RES, RES.DASHBOARDS],
	USERS: [SERVICE.AUTH, USER.LIST],
	USER_ROLES: [SERVICE.AUTH, ROLE.LIST],
};

export const LIST_OF_UNUSED_METHODS: string[] = [
	"GET:/smc/groups",
	"GET:/tts/cache",
	"HEAD:/tts/cache",
	"POST:/tts/split",
	"GET:/ses/robot/listall",
	"WEBSOCKET:/ses/subscribe/*",
	"WEBSOCKET:/ses/subscribe/destination",
	"GET:/res/archive/list",
	"GET:/res/dialog",
	"POST:/auth/checkright",
];
